import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('RadioButton');

const propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.node,
    description: PropTypes.string,
    checked: PropTypes.bool,
    className: PropTypes.string,
    hasError: PropTypes.bool,
    showError: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    verticalCenter: PropTypes.bool,
    additionalLabel: PropTypes.node,
    isCheckoutV3: PropTypes.bool,
    notification: PropTypes.node
};

const defaultValues = {
    checked: false,
    hasError: false,
    showError: false,
    disabled: false,
    verticalCenter: false,
    additionalLabel: null
};

function RadioButton(props) {
    const {
        id,
        label,
        description,
        className,
        labelClass = null,
        children,
        hasError,
        showError,
        disabled,
        img = null,
        value,
        verticalCenter,
        additionalLabel,
        isCheckoutV3,
        notification = null,
        ...rest
    } = props;
    const classname = showError && hasError ? `${className}--radioError` : className;

    const radioButtonElements = () => {
        const labelElements = (
            <>
                <label htmlFor={id} className={labelClass || bem('label')}>{label}</label>
                {additionalLabel}
            </>
        );

        return (
            <>
                {label && (verticalCenter ? <div className={bem('labels')}>{labelElements}</div> : labelElements)}
                {description && <span className={bem('description', { disabled, verticalCenter, isCheckoutV3 })}>{description}</span>}
                {typeof children === 'function' ? children(props) : children}
                {notification && <div className={bem('notification')}>{notification}</div>}
                {img && <div className={img} />}
            </>
        );
    };

    const inputElement = <input type="radio" id={id} disabled={disabled} {...rest} value={value} />;

    return (
        <div className={bem(null, null, [classname, verticalCenter && 'verticalCenter'])}>
            {verticalCenter ? <div className={bem('vertical-input')}>{inputElement}</div> : inputElement}
            {verticalCenter ? <div className={bem()}>{radioButtonElements()}</div> : radioButtonElements()}
        </div>
    );
}

RadioButton.propTypes = propTypes;
RadioButton.defaultValues = defaultValues;

export default RadioButton;
